import React, { useState, useEffect } from 'react'
import './styles.scss'
import logo from 'assets/common/logo.png'
import cart from 'assets/common/cart.svg'
import { Link } from 'react-router-dom'
import useSwitchPage from 'hooks/useSwitchPage'
import { useCartContext } from 'context/shop/CartProvider'
function Header() {
  const switchURL = useSwitchPage()
  const { cartItems } = useCartContext()
  const [totalQuantity, setTotalQuantity] = useState(0)

  useEffect(() => {
    setTotalQuantity(cartItems.reduce((total, item) => total + Number(item.quantity), 0))
  }, [cartItems])
  return (
    <div className="header-frame">
      <div className="header-logo">
        <Link to={switchURL}>
          <img src={logo} alt="Logo" />
        </Link>
      </div>

      <div className="cart-icon">
        <Link to="/cart">
          <img src={cart} alt="Cart" />
          <div className="cart-quantity">
            <span>{totalQuantity}</span>
          </div>
        </Link>
      </div>
    </div>
  )
}

export default Header
